import React, { useEffect, useMemo, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { OnChange } from 'react-final-form-listeners';
import { useFormState, useForm } from 'react-final-form';
import _ from 'lodash';
import { createFilterOptions } from '@material-ui/lab/useAutocomplete';

import QCXAutocompleteSelect from '../../../../shared-components/autocomplete-select/QCXAutocompleteSelect';

export default function QCXAtributoBooleano({ metadado, isConsult, basePath = '', ncm = false, ...restProps }) {
  const listValores = [
    { id: 'true', value: 'Sim' },
    { id: 'false', value: 'Não' },
  ];

  const [label, setLabel] = useState('');
  const [name, setName] = useState('');
  const [obrigatorio, setObrigatorio] = useState(false);
  const [codigo, setCodigo] = useState('');
  const [defaultValue, setDefaultValue] = useState('');
  let path = `atributosPreenchidos`;
  const form = useForm();
  const { values } = form.getState();

  if (basePath) {
    path = `${basePath}.${path}`;
  }

  useEffect(() => {
    setDefaultValue({ id: null, value: '' });
  }, []);

  const filterOptions = createFilterOptions({
    stringify: (item) => `${item.id} - ${item.value}`,
  });

  useEffect(() => {
    if (!ncm) {
      setName(`atributosAdicionais.lpcoForm.jsonFormulario.${metadado?.codigo}.valor`);
    } else {
      setName(`atributosAdicionais.lpcoForm.jsonFormulario.ncm.dados.${metadado?.codigo}.valor`);
    }

    setLabel(metadado?.nome);
    setObrigatorio(metadado?.validacao?.obrigatorio || false);
  }, [metadado]);

  if (!name) {
    return null;
  }

  return (
    <Grid item xs={12} sm={6} md={4}>
      <QCXAutocompleteSelect
        label={label}
        id={name}
        name={name}
        options={listValores}
        filterOptions={filterOptions}
        defaultValue={defaultValue}
        getOptionLabel={(item) => (item.value ? item.value : '')}
        {...restProps}
      />
    </Grid>
  );
}
